<form #fqa="ngForm" (ngSubmit)="fqa.valid && onOk()">
  <div class="title" fxLayout="row" fxLayoutAlign="start">
    <span mat-dialog-title role="heading" aria-level="1">Account Reset</span>
  </div>
  <mat-dialog-content fxLayoutAlign="center" fxLayout="column">
    <mat-form-field floatLabel="always" appearance="outline">
      <mat-label>Question</mat-label>
      <input matInput name="secretQuestion" [ngModel]="question" type="text" readonly>
    </mat-form-field>
    <mat-form-field floatLabel="always" appearance="outline">
      <mat-label>Answer</mat-label>
      <input matInput name="secretAnswer" [(ngModel)]="answer" type="text" required>
    </mat-form-field>
    <div *ngIf="errorText && errorText!=''">
      <mat-error>
        {{errorText}}
      </mat-error>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="fqa.invalid">Ok</button>
  </mat-dialog-actions>
</form>
